import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { CATEGORIES_LOADER } from 'gb-dashboard/item/data-access-categories'
import * as CategoriesActions from 'libs/gb-dashboard/item/data-access-categories/src/lib/+state/categories.actions'
import { CategoriesFacade } from 'libs/gb-dashboard/item/data-access-categories/src/lib/+state/categories.facade'
import { PendingChangesService } from 'libs/gb-dashboard/shared/utils/src/lib/gb-pending-changes/gb-pending-changes.service'
import { GbFormService } from 'libs/shared/utils/services/src/lib/gb-form-service/gb-form.service'
import { Observable, map, take } from 'rxjs'
import { GbEditCategoryComponent } from '../gb-edit-category/gb-edit-category.component'

@Component({
  selector: 'gb-edit-category-dialog',
  templateUrl: './gb-edit-category-dialog.component.html',
  styleUrls: ['./gb-edit-category-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEditCategoryDialogComponent implements OnDestroy, AfterViewInit {
  editCreateLoaded$ = this.categoriesFacade.editCreateLoaded$
  selectedItems$: Observable<string[]> = this.categoriesFacade.selectedCategories$.pipe(
    map((category) => {
      const items = category?.items.map((items) => items) || []
      this.selectedItems = items
      return items
    }),
  )

  @ViewChild('editCategoryComponent')
  editCategoryComponent!: GbEditCategoryComponent

  createCategoryForm!: FormGroup

  selectedItems: string[] = []

  markFormAsTouched = 0

  constructor(
    private categoriesFacade: CategoriesFacade,
    private gbFormService: GbFormService,
    private cd: ChangeDetectorRef,
    private pendingChangesService: PendingChangesService,
  ) {}

  ngAfterViewInit(): void {
    this.createCategoryForm = this.editCategoryComponent.categoryForm
    this.categoriesFacade.selectedCategories$.pipe(take(1)).subscribe((selectedCategory) => {
      this.gbFormService.patchValues(selectedCategory, this.createCategoryForm)
      this.cd.detectChanges()
    })

    this.pendingChangesService.registerPendingChanges(
      this.createCategoryForm,
      this.categoriesFacade.selectedCategories$,
    )
  }

  ngOnDestroy(): void {
    this.categoriesFacade.dispatch(CategoriesActions.clearSelectedCategory())
    this.pendingChangesService.resetPendingChanges()
  }

  submit() {
    this.createCategoryForm.valid ? this.updateCategory() : this.markAsTouched()
  }

  markAsTouched() {
    this.markFormAsTouched++
  }

  selectItems(items: string[]) {
    this.selectedItems = items
  }

  updateCategory() {
    this.categoriesFacade.dispatch(
      CategoriesActions.updateCategory({
        label: this.createCategoryForm.value.label,
        items: this.selectedItems,
      }),
    )
  }

  closeDialog() {
    this.pendingChangesService.closeDialogPendingChanges(GbEditCategoryDialogComponent)
  }

  protected readonly CATEGORIES_LOADER = CATEGORIES_LOADER
}
